export default "__VITE_ASSET__HkyAreYZ__"